import { Record } from 'immutable'
import { getEntityMap } from 'data'

// Record
export const PlanRecord = Record(
  {
    id: '',
    name: '',
    isFree: false,
    monthlyPricePerUser: 0,
    displayOrder: 0,
    discountPercentage: 0,
    altIntervalId: null,
    interval: null,
    product: null,
    amount: 0,
  },
  'Plan'
)

// Selectors
export function getSortedlistOfAvailablePlans(state, { withFree } = {}) {
  return getEntityMap(state, 'Plan')
    .toArray()
    .filter(plan => withFree || !plan.isFree)
    .sort(function byDisplayOrder(planA, planB) {
      return planA.displayOrder - planB.displayOrder
    })
}
